import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import type { Item, OnOpenChangeProps, OnCloseProps } from '../../model/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (switcherType: string) => {
	const camelCaseName = camelCase(switcherType);
	const pascalCaseName = upperFirst(camelCaseName);

	const onClick = ({ isViewAll }: Item, sectionIndex: number) => ({
		name: camelCaseName,
		isViewAll: !!isViewAll,
		sectionIndex,
	});

	const onOpenChange = ({ isOpen }: OnOpenChangeProps) => ({
		name: camelCaseName,
		isOpen,
	});

	const onClose = ({ closedWithoutInteracting }: OnCloseProps) => ({
		name: camelCaseName,
		closedWithoutInteracting,
	});

	const onSearchChange = (search: string) => ({
		name: camelCaseName,
		inputLength: search.length,
	});

	return {
		onOpenChange,
		onClose,
		onClick,
		onSearchChange,
		onShowMore: `showMore${pascalCaseName}`,
		onCreate: `create${pascalCaseName}`,
		onRetry: `retry${pascalCaseName}`,
	};
};
